import PropTypes from "prop-types"
import { useState, useEffect } from "react";
import { capitalizeWord, getOptionFromValueForSelectBox, getPrimaryButtonClass } from "helpers/sf_utils";
import { ADMIN_STATUS, MODE, PRODUCT_TYPES_OPTIONS, USER_NOTIFICATION_BANNER_TYPE } from "helpers/sf_constants";
import ReactMultiselectCheckboxes from "react-multiselect-checkboxes/lib/ReactMultiselectCheckboxes";
import ReactTextareaAutosize from "react-textarea-autosize";
import { Col, Modal, Row, Form, Label, ModalFooter, ModalBody, ModalHeader, UncontrolledTooltip, } from "reactstrap"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"
import Select from "react-select"
import BannerMessage from "./BannerMessage";
import { STR_REQUIRED_ADCREATIVE_URL } from "common/utils/data_validations";

const optionsMessageType = Object.values(USER_NOTIFICATION_BANNER_TYPE).map(el => ({ label: capitalizeWord(el), value: el }))
const AccountsOrUsers = ({ state, onSubmitCreatefeaturesFlag, onCloseStateEvent }) => {
    //for select box
    const [selectedAccounts, setselectedAccounts] = useState([]);
    const [selectedAdminUsers, setselectedAdminUsers] = useState([]);
    const [selectedAdminManageEmployees, setselectedAdminManageEmployees] = useState([]);
    //for options
    const [optionsAccounts, setOptionsAccounts] = useState([{ options: [] }]);
    const [optionsAdminUsers, setOptionsAdminUsers] = useState([{ options: [] }]);
    const [optionsAdminManageEmployees, setOptionsAdminManageEmployees] = useState([{ options: [] }]);

    const [universalUpdate, setUniversalUpdate] = useState(false);
    const [selectedMessageType, setSelectedMessageType] = useState(getOptionFromValueForSelectBox(optionsMessageType, USER_NOTIFICATION_BANNER_TYPE.SUCCESS))
    const [selectedProductType, setSelectedProductType] = useState([])

    useEffect(() => {
        setOptionsAccounts([{ options: setAccountOptionsFromState(state?.accounts_and_users) }]);
        setOptionsAdminUsers([{ options: createAdminUserOptionsFromState(state?.accounts_and_users) }]);
        setOptionsAdminManageEmployees([{ options: createAdminUserOptionsFromState(state?.admin_manage_employees) }]);
    }, [state]);

    function setAccountOptionsFromState(accounts) {
        if (!accounts) return [];
        let options = []
        options.push({ label: 'All Accounts', value: 'all' });
        return options.concat(accounts.map(e => ({ label: `${e.company_name}(${e.accounts[0]?.id})`, value: e.accounts[0]?.id.toString() })))
    }

    function createAdminUserOptionsFromState(adminUsers) {
        if (!adminUsers) return [];
        optionsAdminUsers[0].options = []
        optionsAdminUsers[0].options.push({ label: 'All Users', value: 'all' });
        return optionsAdminUsers[0].options.concat(adminUsers.map(e => ({ label: `${e.first_name} ${e.last_name}(${e?.id})`, value: e.id.toString() })))
    }

    function getDropdownButtonLabelForAccounts({ placeholderButtonLabel, value }) {
        if (value && value.some((o) => o.value === 'all')) {
            return <span className='css-1v99tuv text-black align-self-center'>All Accounts</span>;
        }
        return <span className='css-1v99tuv text-black align-self-center'>{value.length} selected</span>;
    }

    function getDropdownButtonLabelForAdminUsers({ placeholderButtonLabel, value }) {
        if (value && value.some((o) => o.value === 'all')) {
            return <span className='css-1v99tuv text-black align-self-center'>All Users</span>;
        }
        return <span className='css-1v99tuv text-black align-self-center'>{value.length} selected</span>;
    }

    function getDropdownButtonLabelForAdminManageEmployees({ placeholderButtonLabel, value }) {
        if (value && value.some((o) => o.value === 'all')) {
            return <span className='css-1v99tuv text-black align-self-center'>All Users</span>;
        }
        return <span className='css-1v99tuv text-black align-self-center'>{value.length} selected</span>;
    }


    function handleSelectedAccounts(selectedOption, event) {
        if (event.action === 'select-option' && event.option.value === 'all') {
            setselectedAccounts(optionsAccounts[0].options);
        } else if (
            event.action === 'deselect-option'
            && event.option.value === 'all'
        ) {
            setselectedAccounts([]);
        } else if (event.action === 'deselect-option') {
            setselectedAccounts(selectedOption.filter((o) => o.value !== 'all'));
        } else if (selectedOption.length === optionsAccounts[0].options.length - 1) {
            setselectedAccounts(optionsAccounts[0].options);
        } else {
            setselectedAccounts(selectedOption);
        }
    }

    function handleSelectedAdminUsers(selectedOption, event) {
        if (event.action === 'select-option' && event.option.value === 'all') {
            setselectedAdminUsers(optionsAdminUsers[0].options);
        } else if (
            event.action === 'deselect-option'
            && event.option.value === 'all'
        ) {
            setselectedAdminUsers([]);
        } else if (event.action === 'deselect-option') {
            setselectedAdminUsers(selectedOption.filter((o) => o.value !== 'all'));
        } else if (selectedOption.length === optionsAdminUsers[0].options.length - 1) {
            setselectedAdminUsers(optionsAdminUsers[0].options);
        } else {
            setselectedAdminUsers(selectedOption);
        }
    }

    function handleSelectedAdminManageEmployees(selectedOption, event) {
        if (event.action === 'select-option' && event.option.value === 'all') {
            setselectedAdminManageEmployees(optionsAdminManageEmployees[0].options);
        } else if (
            event.action === 'deselect-option'
            && event.option.value === 'all'
        ) {
            setselectedAdminManageEmployees([]);
        } else if (event.action === 'deselect-option') {
            setselectedAdminManageEmployees(selectedOption.filter((o) => o.value !== 'all'));
        } else if (selectedOption.length === optionsAdminManageEmployees[0].options.length - 1) {
            setselectedAdminManageEmployees(optionsAdminManageEmployees[0].options);
        } else {
            setselectedAdminManageEmployees(selectedOption);
        }
    }

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: false,
        initialValues: {
            message: state?.mode === MODE.EDIT ? state?.row?.message || "" : "",
            users: 0,
        },
        validationSchema: Yup.object({
            message: Yup.string().required(STR_REQUIRED_ADCREATIVE_URL),
            users: Yup.string().required(STR_REQUIRED_ADCREATIVE_URL)
            .test(
                "Validate Users",
                STR_REQUIRED_ADCREATIVE_URL,
                (value) => {
                  if (value) {
                    const selectedUsers = selectedAccounts?.length + selectedAdminUsers?.length + selectedAdminManageEmployees?.length + selectedProductType?.length;
                    return state?.mode === MODE.EDIT || parseInt(selectedUsers) > 0
                  }
                  return false;
                },
              ),
        }),
        onSubmit: values => {
            onSubmitForm(values);
        },
    })
    
    const onSubmitForm = (input_values) => {
        const values = { banner_type: selectedMessageType?.value, message: input_values.message, status: ADMIN_STATUS.ACTIVE };
        const product_type = selectedProductType.map(e => e.value) || null;

        const ids = {
            account_ids: selectedAccounts.map(e => e.value) || null,
            admin_manage_client_ids: selectedAdminUsers.map(e => e.value) || null,
            admin_manage_employee_ids: selectedAdminManageEmployees.map(e => e.value) || null,
        }
        onSubmitCreatefeaturesFlag(state, values, ids, product_type);
        onClickCloseModal();
    }

    const onClickCloseModal = () => {
        validation.handleReset();
        setselectedAccounts([]);
        setselectedAdminUsers([]);
        setselectedAdminManageEmployees([]);
        setSelectedMessageType(getOptionFromValueForSelectBox(optionsMessageType, USER_NOTIFICATION_BANNER_TYPE.SUCCESS))
        setSelectedProductType([])
        onCloseStateEvent();
    }

    return (
        <Modal size="lg" isOpen={state?.active} toggle={onClickCloseModal} centered={true} scrollable={true}
            onOpened={() => {
                setSelectedMessageType(getOptionFromValueForSelectBox(optionsMessageType, state?.mode === MODE.EDIT ? state?.row?.banner_type : USER_NOTIFICATION_BANNER_TYPE.SUCCESS))
                // setselectedAccounts(optionsAccounts[0].options.filter(e => state.row.enabled_account_ids.includes(e.value.toString())));
                // setselectedAdminUsers(optionsAdminUsers[0].options.filter(e => state.row.enabled_user_ids.includes(e.value.toString())));

            }}>
            <ModalHeader>
                <h5 className="modal-title text-black mt-0" id="myModalLabel">Notification</h5>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={onClickCloseModal}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={(e) => {
                    e.preventDefault();
                    onClickCloseModal();
                }}>
                    <Row>
                        <Col sm={12}>
                            <Row>
                                <Col md={6} xl>
                                    <div className="mb-2">
                                        <Label>Message Type</Label>
                                        <Select
                                            value={selectedMessageType}
                                            onChange={(option) => {
                                                setSelectedMessageType(option)
                                            }}
                                            options={optionsMessageType}
                                            classNamePrefix="select2-selection"
                                        />
                                    </div>
                                </Col>
                                <Col xl={6} md={6}>
                                {state?.mode === MODE.EDIT ? null : (
                                    <div className="mb-2">
                                        <Label className="">Product Type</Label>
                                        <Select
                                            isMulti={true}
                                            value={selectedProductType}
                                            onChange={(option) => {
                                                setSelectedProductType(option)
                                            }}
                                            options={PRODUCT_TYPES_OPTIONS}
                                            classNamePrefix="select2-selection"
                                        />
                                        {validation.touched.users &&
                                            validation.errors.users ? (
                                            <small className="text-danger">
                                                {validation.errors.users}
                                            </small>
                                        ) : null}
                                    </div>)}
                                </Col>
                                <Col sm={12}>
                                    {state?.mode === MODE.EDIT ? null : (
                                        <div className={universalUpdate && "d-none"} >
                                            <Row className="mb-2">
                                                <Col xl={6} md={6} className="mb-2">
                                                    <UncontrolledTooltip
                                                        placement="top"
                                                        target="user-notification-select-accoount"
                                                    >
                                                        Select the account(s) you want to create the notification for
                                                    </UncontrolledTooltip>
                                                    <Label className="mb-2" id="user-notification-select-accoount">
                                                        Select Accounts
                                                    </Label>
                                                    <ReactMultiselectCheckboxes
                                                        isDisabled={universalUpdate}
                                                        styles={{ menu: base => ({ ...base, maxHeight: "180px", height: "180px", overflowY: "scroll" }) }}
                                                        className="sf-checkbox"
                                                        getDropdownButtonLabel={getDropdownButtonLabelForAccounts}
                                                        value={selectedAccounts}
                                                        onChange={(selectedOption, event) => {
                                                            handleSelectedAccounts(selectedOption, event);
                                                        }}
                                                        options={optionsAccounts[0].options}
                                                    />
                                                    {validation.touched.users &&
                                                        validation.errors.users ? (
                                                        <small className="text-danger">
                                                            {validation.errors.users}
                                                        </small>
                                                    ) : null}
                                                </Col>
                                                <Col xl={6} md={6} className="mb-2">
                                                    <Label className="mb-2" id="user-notification-select-users">
                                                        Select Users
                                                    </Label>
                                                    <UncontrolledTooltip
                                                        placement="top"
                                                        target="user-notification-select-users"
                                                    >
                                                        Select user(s) you want to create notification for
                                                    </UncontrolledTooltip>
                                                    <ReactMultiselectCheckboxes
                                                        styles={{ menu: base => ({ ...base, maxHeight: "180px", height: "180px", overflowY: "scroll" }) }}
                                                        className="sf-checkbox"
                                                        isDisabled={universalUpdate}
                                                        getDropdownButtonLabel={getDropdownButtonLabelForAdminUsers}
                                                        value={selectedAdminUsers}
                                                        onChange={(selectedOption, event) => {
                                                            handleSelectedAdminUsers(selectedOption, event);
                                                        }}
                                                        options={optionsAdminUsers[0].options}
                                                    />
                                                    {validation.touched.users &&
                                                        validation.errors.users ? (
                                                        <small className="text-danger">
                                                            {validation.errors.users}
                                                        </small>
                                                    ) : null}
                                                </Col>

                                                <Col xl={6} md={6} className="mb-2">
                                                    <Label className="mb-2" id="user-notification-select-admin-users">
                                                        Select Admin(s)
                                                    </Label>
                                                    <UncontrolledTooltip
                                                        placement="top"
                                                        target="user-notification-select-admin-users"
                                                    >
                                                        Select the admin user(s) you want to create the notification for
                                                    </UncontrolledTooltip>
                                                    <ReactMultiselectCheckboxes
                                                        styles={{ menu: base => ({ ...base, maxHeight: "180px", height: "180px", overflowY: "scroll" }) }}
                                                        className="sf-checkbox"
                                                        isDisabled={universalUpdate}
                                                        getDropdownButtonLabel={getDropdownButtonLabelForAdminManageEmployees}
                                                        value={selectedAdminManageEmployees}
                                                        onChange={(selectedOption, event) => {
                                                            handleSelectedAdminManageEmployees(selectedOption, event);
                                                        }}
                                                        options={optionsAdminManageEmployees[0].options}
                                                    />
                                                    {validation.touched.users &&
                                                        validation.errors.users ? (
                                                        <small className="text-danger">
                                                            {validation.errors.users}
                                                        </small>
                                                    ) : null}
                                                </Col>
                                            </Row>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={12}>
                            <div className="mb-3">
                                <Label>Message</Label>
                                <ReactTextareaAutosize
                                    minRows={4}
                                    type='text'
                                    className={`form-control`}
                                    name="message"
                                    value={validation.values.message}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    placeholder="Enter Message..."
                                />
                                {validation.touched.message &&
                                    validation.errors.message ? (
                                    <small className="text-danger">
                                        {validation.errors.message}
                                    </small>
                                ) : null}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <Label>Html Preview</Label>
                                <BannerMessage banner={{ message: validation.values.message, banner_type: selectedMessageType?.value }} onClickClose={() => { }} />
                            </div>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Col md={12}>
                    <div className="float-end">
                        <button
                            type="submit"
                            className={`btn ${getPrimaryButtonClass()} me-3`}
                            name="submit"
                            onClick={(e) => {
                                e.preventDefault();
                                validation.handleSubmit()
                            }}
                        >{state?.mode === MODE.EDIT ? "Save" : "Create"}</button>
                        <button
                            type="button"
                            onClick={onClickCloseModal}
                            className="btn btn-light me-3"
                            data-dismiss="modal"
                        >Cancel</button>
                    </div>
                </Col>
            </ModalFooter>
        </Modal >
    )
}

AccountsOrUsers.propTypes = {
    onCloseStateEvent: PropTypes.func,
    onSubmitCreatefeaturesFlag: PropTypes.func,
    state: PropTypes.object,
}

export default AccountsOrUsers;
